import Mobile from './Mobile'

export default Mobile
// eslint-disable-next-line import/export
export * from './Mobile'
